import { SLIDER_ADD_FAIL, SLIDER_ADD_REQUEST, SLIDER_ADD_SUCCESS, SLIDER_CLEAR, SLIDER_DELETE_FAIL, SLIDER_DELETE_REQUEST, SLIDER_DELETE_SUCCESS, SLIDER_EDIT_FAIL, SLIDER_EDIT_REQUEST, SLIDER_EDIT_RESET, SLIDER_EDIT_SUCCESS, SLIDER_LIST_FAIL, SLIDER_LIST_REQUEST, SLIDER_LIST_SUCCESS, SLIDER_UPDATE_FAIL, SLIDER_UPDATE_REQUEST, SLIDER_UPDATE_RESET, SLIDER_UPDATE_SUCCESS } from "../Constants/SliderConstans";
  
  export const SliderAddReducers = (state = { sliderInfo: {} }, action) => {
    switch (action.type) {
      case SLIDER_ADD_REQUEST:
        return { loading: true };
      case SLIDER_ADD_SUCCESS:
        return { loading: false, success: true, slider: action.payload };
      case SLIDER_ADD_FAIL:
        return { loading: false, error: action.payload };
      case SLIDER_CLEAR:
        return {};
      default:
        return state;
    }
  };
  
  export const SliderListReducers = (
    state = { slider: [], currentPage: 1, totalPages: 0, totalRecords: 0, recordSize: 4 },
    action
  ) => {
    switch (action.type) {
      case SLIDER_LIST_REQUEST:
        return { ...state, loading: true };
      case SLIDER_LIST_SUCCESS:
        return {
          loading: false,
          slider: action.payload.sliders,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalRecords: action.payload.totalRecords,
          recordSize: action.payload.recordSize,
        };
      case SLIDER_LIST_FAIL:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  

  export const SliderEditReducers = (
    state = { slider: {} },
    action
  ) => {
    switch (action.type) {
      case SLIDER_EDIT_REQUEST:
        return { ...state, loading: true, error: null };
      case SLIDER_EDIT_SUCCESS:
        return { loading: false, slider: action.payload };
      case SLIDER_EDIT_FAIL:
        return { loading: false, error: action.payload };
      case SLIDER_EDIT_RESET:
        return { slider: {} };
      default:
        return state;
    }
  };

  export const SliderUpdateReducers = (state = { slider: {} }, action) => {
    switch (action.type) {
      case SLIDER_UPDATE_REQUEST:
        return { ...state, loading: true };
      case SLIDER_UPDATE_SUCCESS:
        return { loading: false, success: true, slider: action.payload };
      case SLIDER_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      case SLIDER_UPDATE_RESET:
        return { slider: {} };
      default:
        return state;
    }
  };
  export const SliderDeleteReducers = (state = {}, action) => {
    switch (action.type) {
      case SLIDER_DELETE_REQUEST:
        return { loading: true };
      case SLIDER_DELETE_SUCCESS:
        return { loading: false, success: true };
      case SLIDER_DELETE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  